/**
 * Is the signed-in user a guest (decision 2026-09-29)? Set by the application when the login
 * state is known; a guest can read the chats but not write in them.
 */
export const guestSession = { guest: false };
